// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1327":"213334f09cabc898","4828":"b6b2768f44b81c1b","5894":"b4d09422e6e3ffe4"}[chunkId] + ".css";
};